import { getWidgetAttributes } from '@sportal365/smp-widget-utils';
import { Sports } from '../../../../../packages/constants/sportType';
import WidgetAttributes from '../../../../../packages/constants/widgetAttributes';
import { STANDINGS } from '../../../../../packages/constants/widgetIds';

export const standingsAttributes = getWidgetAttributes(
  STANDINGS,
  // Required attributes:
  [WidgetAttributes.WIDGET_SPORT, WidgetAttributes.WIDGET_TYPE, WidgetAttributes.WIDGET_ID, WidgetAttributes.COMPETITION],
  // Optional attributes:
  [
    WidgetAttributes.NAME_TYPE,
    WidgetAttributes.THEME,
    WidgetAttributes.STAGE,
    WidgetAttributes.SEASON,
    WidgetAttributes.HEADER_DISPLAY,
    WidgetAttributes.REFRESH_TIME,
    WidgetAttributes.ENTITY_LINKS,
    WidgetAttributes.LABELS,
    WidgetAttributes.HEADER_DEFAULT_OPTION,
    WidgetAttributes.OPTIONS_DISPLAY,
    WidgetAttributes.IMAGE_DISPLAY,
    WidgetAttributes.DATA_HIGHLIGHT_ENTITIES,
    WidgetAttributes.NAME_TYPE,
    WidgetAttributes.OPTIONS_DISPLAY,
  ],
  Sports.BASKETBALL,
);
